import React from 'react';
import './PageShell.css';

export interface PageShellProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: 'default' | 'narrow' | 'wide';
  children?: React.ReactNode;
}

const PageShell: React.FC<PageShellProps> = ({
  width = 'default',
  className = '',
  children,
  ...rest
}) => {
  const classes = [
    'page-shell',
    width === 'narrow' ? 'page-shell--narrow' : '',
    width === 'wide' ? 'page-shell--wide' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default PageShell;
